export default function StepUs3() {
    return (
        <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_5662_70437" fill="white">
                <path d="M26.75 24.2065C29.7876 24.2065 32.25 21.7441 32.25 18.7065C32.25 15.669 29.7876 13.2065 26.75 13.2065" />
            </mask>
            <path
                d="M26.75 24.9565C30.2018 24.9565 33 22.1583 33 18.7065H31.5C31.5 21.3299 29.3734 23.4565 26.75 23.4565V24.9565ZM33 18.7065C33 15.2547 30.2018 12.4565 26.75 12.4565V13.9565C29.3734 13.9565 31.5 16.0832 31.5 18.7065H33Z"
                fill="#3F68E0"
                mask="url(#path-1-inside-1_5662_70437)"
            />
            <path
                d="M26.75 24.2065C29.7876 24.2065 32.25 21.7441 32.25 18.7065C32.25 15.669 29.7876 13.2065 26.75 13.2065"
                stroke="#3F68E0"
                strokeWidth="1.134"
                strokeLinejoin="round"
            />
            <mask id="path-4-inside-2_5662_70437" fill="white">
                <path d="M10.25 13.2065C7.21243 13.2065 4.75 15.669 4.75 18.7065C4.75 21.7441 7.21243 24.2065 10.25 24.2065" />
            </mask>
            <path
                d="M10.25 12.4565C6.79822 12.4565 4 15.2547 4 18.7065H5.5C5.5 16.0832 7.62664 13.9565 10.25 13.9565V12.4565ZM4 18.7065C4 22.1583 6.79822 24.9565 10.25 24.9565V23.4565C7.62664 23.4565 5.5 21.3299 5.5 18.7065H4Z"
                fill="#3F68E0"
                mask="url(#path-4-inside-2_5662_70437)"
            />
            <path
                d="M10.25 13.2065C7.21243 13.2065 4.75 15.669 4.75 18.7065C4.75 21.7441 7.21243 24.2065 10.25 24.2065"
                stroke="#3F68E0"
                strokeWidth="1.134"
                strokeLinejoin="round"
            />
            <path
                d="M10.25 24.2065V23.8628V22.144V18.7065V13.2065C10.25 8.65019 13.9437 4.95654 18.5 4.95654C23.0563 4.95654 26.75 8.65019 26.75 13.2065V24.2065C26.75 28.7629 23.0563 32.4565 18.5 32.4565"
                stroke="#3F68E0"
                strokeWidth="1.134"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
